function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import _ from 'underscore';
import { createHashHistory } from 'history';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import entityComposition from '../common/classes/entityComposition';
import DocumentsRow from './documentsRow';
import DocumentPagingTable from './documentPagingTable';
import ListPanel from '../common/containers/listPanel';
import DocumentsFilters from './documentsFilters';
import DocumentsBulkActions from './documentsBulkActions';
import { editPermissionSelector, viewPermissionSelector } from '../common/classes/permissions';
import routeHelper from '../common/classes/routeHelper';
const hashHistory = createHashHistory();
const handleSelectAll = (event, document, documentActions) => {
  if (event && event.target.checked) {
    documentActions.selectAll(document.list.map(i => i.id));
  } else {
    documentActions.selectClearAll();
  }
};
class Documents extends Component {
  constructor(props) {
    super(props);
    const {
      documentActions,
      document
    } = this.props;
    // only want open jobs
    documentActions.serverIndex(document.indexQuery);
    this.handleAdd = () => hashHistory.replace('/library/upload');
    this.handleClick = id => hashHistory.replace(`/library/${id}`);
    this.filterChange = this.filterChange.bind(this);
    this.filterClear = this.filterClear.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }
  componentDidMount() {
    const {
      canView,
      location
    } = this.props;
    // Redirect and post authorization error message if permissions insufficient
    routeHelper.handleViewRedirect(canView, location);
  }
  handleSelect(id, event) {
    const {
      documentActions
    } = this.props;
    if (event.target.checked) {
      documentActions.select(id);
    } else {
      documentActions.selectClear(id);
    }
  }
  filterChange(prop, value) {
    const {
      documentActions,
      document
    } = this.props;
    documentActions.serverFilter(_objectSpread(_objectSpread({}, document.indexQuery.filters), {}, {
      [prop]: value
    }), document.indexQuery);
  }
  filterClear() {
    const {
      document: {
        initialIndexQuery
      },
      documentTagIndexQuery,
      documentTagInitialIndexQuery,
      documentTagFilterDocumentActions,
      jobIndexQuery,
      jobInitialIndexQuery,
      jobFilterDocumentActions,
      documentActions
    } = this.props;
    documentActions.serverIndex(initialIndexQuery);
    if (documentTagIndexQuery.initialized) {
      documentTagFilterDocumentActions.serverIndex(documentTagInitialIndexQuery);
    }
    if (jobIndexQuery.initialized) {
      jobFilterDocumentActions.serverIndex(jobInitialIndexQuery);
    }
  }
  render() {
    const {
      document,
      documentActions,
      canEdit
    } = this.props;
    const {
      indexQuery,
      list,
      selected
    } = document;
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(DocumentsFilters, {
      filters: indexQuery.filters,
      onFilterChange: this.filterChange,
      onFilterClear: this.filterClear
    }), /*#__PURE__*/React.createElement(Col, {
      sm: 9
    }, /*#__PURE__*/React.createElement(ListPanel, {
      title: "Library Documents",
      showNew: canEdit,
      onAdd: this.handleAdd,
      actionButton: canEdit ? /*#__PURE__*/React.createElement(DocumentsBulkActions, {
        document: document,
        documentActions: documentActions
      }) : undefined
    }, /*#__PURE__*/React.createElement(DocumentPagingTable, {
      headers: canEdit ? [/*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        onChange: event => handleSelectAll(event, document, documentActions)
      }), 'Name', 'Created', 'Creator', 'Size'] : ['Name', 'Created', 'Creator', 'Size'],
      loading: document.loading,
      indexQuery: indexQuery
    }, list.map((doc, index) => /*#__PURE__*/React.createElement(DocumentsRow, {
      index: index,
      key: `DR_${doc.id}`,
      data: doc,
      onClick: this.handleClick,
      onChange: this.handleSelect,
      isSelected: _.contains(selected, doc.id),
      hasActions: canEdit
    })))))));
  }
}
Documents.defaultProps = {
  document: {},
  location: {}
};
Documents.propTypes = {
  document: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
    loading: PropTypes.bool,
    initialIndexQuery: PropTypes.shape({}),
    indexQuery: PropTypes.shape({
      filters: PropTypes.shape({})
    }).isRequired,
    selected: PropTypes.arrayOf(PropTypes.string)
  }),
  // document redux store
  documentTagFilterDocumentActions: PropTypes.shape({
    serverIndex: PropTypes.func,
    serverFilter: PropTypes.func
  }).isRequired,
  documentTagIndexQuery: PropTypes.shape({
    initialized: PropTypes.bool,
    filters: PropTypes.shape({})
  }).isRequired,
  documentTagInitialIndexQuery: PropTypes.shape({}).isRequired,
  jobFilterDocumentActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  jobIndexQuery: PropTypes.shape({
    initialized: PropTypes.bool,
    filters: PropTypes.shape({})
  }).isRequired,
  jobInitialIndexQuery: PropTypes.shape({}).isRequired,
  documentActions: PropTypes.shape({
    select: PropTypes.func,
    selectClear: PropTypes.func,
    serverIndex: PropTypes.func,
    serverFilter: PropTypes.func
  }).isRequired,
  // document redux actions
  canView: PropTypes.bool.isRequired,
  // permissions booleans
  canEdit: PropTypes.bool.isRequired,
  // permissions booleans
  location: PropTypes.shape({}) // from the router
};
export { Documents as TestDocuments };
export default entityComposition(Documents, ['document'], {
  canEdit: state => editPermissionSelector('document')(state),
  canView: state => viewPermissionSelector('document')(state),
  documentTagIndexQuery: state => state.documentTagFilterDocument.indexQuery,
  documentTagInitialIndexQuery: state => state.documentTagFilterDocument.initialIndexQuery,
  jobIndexQuery: state => state.jobFilterDocument.indexQuery,
  jobInitialIndexQuery: state => state.jobFilterDocument.initialIndexQuery
}, ['documentTagFilterDocument', 'jobFilterDocument']);